import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import Tabs from '../../../components/Tabs';
import props from '../../../lib/contentLayoutProps/life-at-kingston/layoutProps';

const tabs = ['Kindergarten / Children Centre', 'Primary School'];

/* eslint-disable react/prop-types */
export default class extends React.Component {
  state = {
    tab: 0,
  };

  render() {
    const { tab } = this.state;

    return (
      <ContentLayout {...props} locale="en" pageKey="weather-information">
        <h1>Weather Information</h1>
        <p>
          Kingston follows the Education Bureau arrangements for Kindergartens in tropical cyclones and heavy persistent
          rain. For the most updated information on school closures in bad weather please check the{' '}
          <a href="http://www.edb.gov.hk" target="_blank" rel="noopener noreferrer">
            EDB website
          </a>. The school will also notify parents by email of school closure information as it is received.
        </p>

        <Tabs tabs={tabs} onChangeTab={index => this.setState({ tab: index })} />
        {tab === 0 && (
          <React.Fragment>
            <h3>Typhoon Signals</h3>
            <table>
              <tbody>
                <tr>
                  <td style={{ width: '30%' }}>No. 1 Typhoon Signal</td>
                  <td>School operates as normal unless otherwise advised</td>
                </tr>
                <tr>
                  <td>No. 3 Typhoon Signal</td>
                  <td>Classes are suspended</td>
                </tr>
                <tr>
                  <td>No. 8 Typhoon Signal</td>
                  <td>Classes are suspended</td>
                </tr>
                <tr>
                  <td>No.8 Typhoon Signal or above replaced by No.3 Typhoon Signal</td>
                  <td>Classes remain suspended</td>
                </tr>
                <tr>
                  <td>
                    No.3 Typhoon Signal replaced by No.1 Signal or when all tropical cyclone signals are cancelled
                  </td>
                  <td>
                    Classes resume with the next session unless previous announcement has been made to the effect that
                    classes will be suspended for the entire day
                  </td>
                </tr>
              </tbody>
            </table>

            <h3>Rainstorm Signals</h3>
            <table>
              <tbody>
                <tr>
                  <td style={{ width: '30%' }}>Amber Rainstorm Signal</td>
                  <td>School operates as normal</td>
                </tr>
                <tr>
                  <td>Red and Black Rainstorm Signal</td>
                  <td>
                    <div style={{ marginBottom: '8px' }}>
                      <strong>Issued from 5:30am onwards and before 8:00am</strong>
                      <br />AM classes are suspended
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <strong>Issued from 10:30am onwards and before 1:00pm</strong>
                      <br />AM classes continue as usual and students will be allowed to leave once conditions are safe
                      <br />PM Classes are suspended
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <strong>Issued from 1:00pm onwards</strong>
                      <br />Classes continue as usual and students will be allowed to leave once conditions are safe
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </React.Fragment>
        )}

        {tab === 1 && (
          <React.Fragment>
            <h3>Typhoon Signals</h3>
            <table>
              <tbody>
                <tr>
                  <td style={{ width: '30%' }}>No. 1 Typhoon Signal</td>
                  <td>School operates as normal</td>
                </tr>
                <tr>
                  <td>No. 3 Typhoon Signal</td>
                  <td>
                    School operates as normal unless the Education Bureau announces that full day classes are cancelled.
                    Parents should listen to Public announcements on the television or radio or check the{' '}
                    <a href="http://www.edb.gov.hk" target="_blank" rel="noopener noreferrer">
                      EDB website
                    </a>{' '}
                    for details.
                  </td>
                </tr>
                <tr>
                  <td>No. 8 Typhoon Signal</td>
                  <td>School will be closed</td>
                </tr>
              </tbody>
            </table>

            <h3>Rainstorm Signals</h3>
            <table>
              <tbody>
                <tr>
                  <td style={{ width: '30%' }}>Amber Rainstorm Signal</td>
                  <td>School operates as normal</td>
                </tr>
                <tr>
                  <td>Red Rainstorm Signal</td>
                  <td>
                    When the Red Rainstorm Warning Signal is in force before 8am school will be closed should the EDB
                    announce closure of schools
                  </td>
                </tr>
                <tr>
                  <td>Black Rainstorm Signal</td>
                  <td>When the Black Rainstorm Warning Signal is in force before 8am school will be closed</td>
                </tr>
              </tbody>
            </table>
          </React.Fragment>
        )}

        <p>
          If the Typhoon 8 signal or Black Rainstorm signal are hoisted during school hours, parents should make
          arrangements to pick their child up as soon as it is safe to do so. The school will remain open until all
          students have been picked up. As always it is up to parents to decide whether they wish to send their children
          out when weather conditions are bad.
        </p>
        <p>
          Please note that if a Black Rainstorm Signal is in force, children that travel home by school bus will not be
          permitted to board school buses. Parents are requested to contact their school bus provider directly to make
          arrangements.
        </p>
      </ContentLayout>
    );
  }
}
